var map = {
	"./fineReport.svg": "9e75",
	"./home.svg": "0331",
	"./info.svg": "b888",
	"./password.svg": "198d",
	"./pchome.svg": "02db",
	"./salesData.svg": "9478",
	"./supplier.svg": "3e27",
	"./system.svg": "922f",
	"./user.svg": "d88a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";